module.exports = {"10x10": __webpack_public_path__ + "images/comet-5-10x10.png"};